module.exports = __webpack_public_path__ + "img/solution4.e4029862.png";